import * as React from 'react'
import { List, Datagrid, Edit, Create, SimpleForm, TextField, EditButton, TextInput } from 'react-admin'
import TagFacesIcon from '@material-ui/icons/TagFaces'

export const TagIcon = TagFacesIcon

export const TagList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField label='Chave' source='id' />
      <TextField label='Nome' source='name' />
      <TextField label='Tipo' source='tag_type' />
      <TextField label='Descrição' source='description' />
      <EditButton basePath='/tags' />
    </Datagrid>
  </List>
)

const TagTitle = ({ record }) => {
  return <span>Tag {record ? `"${record.title}"` : ''}</span>
}

export const TagEdit = (props) => (
  <Edit title={<TagTitle />} {...props}>
    <SimpleForm>
      <TextInput disabled label='Chave' source='id' />
      <TextInput label='Nome' source='name' />
      <TextInput label='Tipo' source='tag_type' />
      <TextInput label='Descrição' source='description' multiline />
    </SimpleForm>
  </Edit>
)

export const TagCreate = (props) => (
  <Create title='Criar nova tag' {...props}>
    <SimpleForm>
      <TextInput label='Chave' source='id' />
      <TextInput label='Nome' source='name' />
      <TextInput label='Tipo' source='tag_type' />
      <TextInput label='Descrição' source='description' multiline />
    </SimpleForm>
  </Create>
)
